
// import React from 'react';
// // import { makeStyles } from '@material-ui/core/styles';
// import { makeStyles } from "@material-ui/core/styles";
// import { withRouter } from "react-router-dom";
// import './SideBar.css';
// import DashboardRoundedIcon from '@material-ui/icons/DashboardRounded';
// import RoomRoundedIcon from '@material-ui/icons/RoomRounded';
// import EditLocationRoundedIcon from '@material-ui/icons/EditLocationRounded';
// import ReportProblemRoundedIcon from '@material-ui/icons/ReportProblemRounded';
// import MapRoundedIcon from '@material-ui/icons/MapRounded';
// import QueryBuilderRoundedIcon from '@material-ui/icons/QueryBuilderRounded';
// import PersonAddRoundedIcon from '@material-ui/icons/PersonAddRounded';
// import ExitToAppTwoToneIcon from '@material-ui/icons/ExitToAppTwoTone';
// import {
//   Drawer as MUIDrawer,
//   ListItem,
//   List,
//   ListItemIcon,
//   ListItemText
// } from "@material-ui/core";



// // const drawerWidth = 240;


// const useStyles = makeStyles({

  

//   // root: {
//   //   boxShadow: "0px 15px 6px -6px black",
//   //   backgroundColor: 'purple',
//   //   elevation: "50"
//   // },

//   drawer: {
//     backgroundColor: 'blue',
//     // root: 'pink',
//     width: "230px",
//     boxShadow: '10 5px 5px 2px rgba(255, 105, 135, .3)',
//     // boxShadow: '10px 6px 6px -6px black',
//     // elevation: '10'
//   },

//   list: {
//     // backgroundColor: 'pink',
//     width: "230px",
//     // fontSize: "72.2px",
//     // fontWeight: "bold",
//     // textDecoration: "underline"
//     // boxShadow: '10px 6px 6px -6px black',

//   },
  
//   // listItem: {
//   //   // backgroundColor: 'pink',
//   //   width: "230px",
//   //   // fontSize: "10vh",
//   //   // fontWeight: "bold",
//   //   // textDecoration: "underline"
//   //   // boxShadow: '10px 6px 6px -6px black',

//   // },

//   // logout: {
//   //   // backgroundColor: 'purple',
//   //   width: "230px",
//   //   marginTop: '100px',
//   //   // border:'0.2vh solid black'
//   //   // boxShadow: '10px 6px 6px -6px black',

//   // }

//   // click: {
//   //   backgroundColor: 'lightblue',
//   //   color: '#ffffff',
//   // }

// });

// // export default function ClippedDrawer() {
// // const classes = useStyles();

// const Drawer = props => {
//   const { history } = props;
//   const classes = useStyles();
//   const itemsList = [
//     {
//       text: "Dashboard",
//       icon: < DashboardRoundedIcon />,
//       onClick: () => history.push("/")
//     },
//     {
//       text: "Zones",
//       icon: <RoomRoundedIcon />,
//       onClick: () => history.push("/zones")
//     },
//     {
//       text: "Relaxing Zones",
//       icon: <EditLocationRoundedIcon />,
//       onClick: () => history.push("/relaxingzones")
//     },
//     {
//       text: "Map",
//       icon: <MapRoundedIcon />,
//       onClick: () => history.push("/maps")
//     },
//     {
//       text: "Violations",
//       icon: <ReportProblemRoundedIcon />,
//       onClick: () => history.push("/violations")
//     },
//     {
//       text: "Queries",
//       icon: <QueryBuilderRoundedIcon />,
//       onClick: () => history.push("/query")
//     },
//     {
//       text: "Register",
//       icon: <PersonAddRoundedIcon />,
//       onClick: () => history.push("/register")
//     },
//   ];

//   // const logout = [
//   //   {
//   //     text: "Logout",
//   //     icon: <ExitToAppTwoToneIcon />,
//   //     onClick: () => history.push("/register")
//   //   },
//   // ];

//   return (

//     <MUIDrawer variant="permanent" className={'drawer'}>

//       <div style={{ height: '225.6px', width: '230px', display: 'flex', alignItems: 'center', marginTop:'9vh'}}>
//         <img src="https://firebasestorage.googleapis.com/v0/b/fyp-pscs-7e191.appspot.com/o/Logo%2Btext.png?alt=media&token=93540c12-a601-4ab2-ac0d-31c48ebc8cac"
//           style={{ height: '202.16px', width: '100%', position: 'sticky', margin: '15px', borderBottom: '0.4vh solid #5499C7', padding: '15px' }}
//         />
//       </div>

//       <List className={'listCss'}>
//         {itemsList.map((item, index) => {
//           const { text, icon, onClick } = item;
//           return (
//             <div className={'listDiv'}>
//               <ListItem className={'listitemstyle'} button key={text} onClick={onClick} >
//                 {/* <div className={'listItemDiv'}> */}
//               {icon && <ListItemIcon className={'listIcon'}>{icon}</ListItemIcon>}
//               <ListItemText primary={text} className={'listItemText'} />
//               {/* </div> */}

//             </ListItem>
//              </div>
            
//           );
//         })}
//       </List>
//       {/* <List className={classes.logout}>
//         {logout.map((item, index) => {
//           const { text, icon, onClick } = item;
//           return (
//             <ListItem button key={text} onClick={onClick} >
//               {icon && <ListItemIcon>{icon}</ListItemIcon>}
//               <ListItemText primary={text} />
//             </ListItem>
//           );
//         })}
//       </List> */}

//     </MUIDrawer>

//   );
// }
// export default withRouter(Drawer);


import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import './SideBar.css';
import DashboardRoundedIcon from '@material-ui/icons/DashboardRounded';
import RoomRoundedIcon from '@material-ui/icons/RoomRounded';
import EditLocationRoundedIcon from '@material-ui/icons/EditLocationRounded';
import ReportProblemRoundedIcon from '@material-ui/icons/ReportProblemRounded';
import MapRoundedIcon from '@material-ui/icons/MapRounded';
import QueryBuilderRoundedIcon from '@material-ui/icons/QueryBuilderRounded';
import PersonAddRoundedIcon from '@material-ui/icons/PersonAddRounded';
import ExitToAppTwoToneIcon from '@material-ui/icons/ExitToAppTwoTone';
import {
  Drawer as MUIDrawer,
  ListItem,
  List,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";



// const drawerWidth = 240;


const useStyles = makeStyles({

  

  // root: {
  //   boxShadow: "0px 15px 6px -6px black",
  //   backgroundColor: 'purple',
  //   elevation: "50"
  // },

  drawer: {
    backgroundColor: 'blue',
    // root: 'pink',
    width: "230px",
    boxShadow: '10 5px 5px 2px rgba(255, 105, 135, .3)',
    // boxShadow: '10px 6px 6px -6px black',
    // elevation: '10'
  },

  list: {
    // backgroundColor: 'pink',
    width: "230px",
    // fontSize: "72.2px",
    // fontWeight: "bold",
    // textDecoration: "underline"
    // boxShadow: '10px 6px 6px -6px black',

  },
  
  // listItem: {
  //   // backgroundColor: 'pink',
  //   width: "230px",
  //   // fontSize: "10vh",
  //   // fontWeight: "bold",
  //   // textDecoration: "underline"
  //   // boxShadow: '10px 6px 6px -6px black',

  // },

  // logout: {
  //   // backgroundColor: 'purple',
  //   width: "230px",
  //   marginTop: '100px',
  //   // border:'0.2vh solid black'
  //   // boxShadow: '10px 6px 6px -6px black',

  // }

  // click: {
  //   backgroundColor: 'lightblue',
  //   color: '#ffffff',
  // }

});

// export default function ClippedDrawer() {
// const classes = useStyles();

const Drawer = props => {
  const { history } = props;
  const classes = useStyles();
  const itemsList = [
    {
      text: "Dashboard",
      icon: < DashboardRoundedIcon />,
      onClick: () => history.push("/dashboard")
    },
    {
      text: "Zones",
      icon: <RoomRoundedIcon />,
      onClick: () => history.push("/zones")
    },
    {
      text: "Relaxing Zones",
      icon: <EditLocationRoundedIcon />,
      onClick: () => history.push("/relaxingzones")
    },
    {
      text: "Map",
      icon: <MapRoundedIcon />,
      onClick: () => history.push("/maps")
    },
    {
      text: "Violations",
      icon: <ReportProblemRoundedIcon />,
      onClick: () => history.push("/violations")
    },
    {
      text: "Queries",
      icon: <QueryBuilderRoundedIcon />,
      onClick: () => history.push("/query")
    },
    {
      text: "Register",
      icon: <PersonAddRoundedIcon />,
      onClick: () => history.push("/register")
    },
  ];

  // const logout = [
  //   {
  //     text: "Logout",
  //     icon: <ExitToAppTwoToneIcon />,
  //     onClick: () => history.push("/register")
  //   },
  // ];

  return (

    <MUIDrawer variant="permanent" className={'drawer'}>

      <div style={{ height: '225.6px', width: '230px', display: 'flex', alignItems: 'center', marginTop:'9vh'}}>
        <img src="https://firebasestorage.googleapis.com/v0/b/fyp-pscs-7e191.appspot.com/o/Logo%2Btext.png?alt=media&token=93540c12-a601-4ab2-ac0d-31c48ebc8cac"
          style={{ height: '202.16px', width: '100%', position: 'sticky', margin: '15px', borderBottom: '0.4vh solid #5499C7', padding: '15px' }}
        />
      </div>

      <List className={'listCss'}>
        {itemsList.map((item, index) => {
          const { text, icon, onClick } = item;
          return (
            <div className={'listDiv'}>
              <ListItem className={'listitemstyle'} button key={text} onClick={onClick} >
                {/* <div className={'listItemDiv'}> */}
              {icon && <ListItemIcon className={'listIcon'}>{icon}</ListItemIcon>}
              <ListItemText primary={text} className={'listItemText'} />
              {/* </div> */}

            </ListItem>
             </div>
            
          );
        })}
      </List>
      {/* <List className={classes.logout}>
        {logout.map((item, index) => {
          const { text, icon, onClick } = item;
          return (
            <ListItem button key={text} onClick={onClick} >
              {icon && <ListItemIcon>{icon}</ListItemIcon>}
              <ListItemText primary={text} />
            </ListItem>
          );
        })}
      </List> */}

    </MUIDrawer>

  );
}
export default withRouter(Drawer);
